import Box from '@mui/material/Box';
import Button, { ButtonProps } from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { FeatureFlag } from '@cbo/shared-library';
import SplitButton from '../../../components/SplitButton/SplitButton';
import { useFeatureFlag } from '../../../utils/hooks/useFeatureFlag';

interface ReportsDropdownProps extends ButtonProps {
  onCreateReport: () => void;
  onScheduleReport?: () => void;
}

function ReportsDropdown({ disabled, onCreateReport, onScheduleReport }: Readonly<ReportsDropdownProps>) {
  const { t } = useTranslation();
  const isScheduleReportEnabled = useFeatureFlag(FeatureFlag.scheduledReport);

  const handleScheduleReport = () => {
    if (onScheduleReport) onScheduleReport();
  };

  const options = [
    {
      text: t('admin.customReports.createReport'),
      callback: onCreateReport,
    },
    ...(isScheduleReportEnabled
      ? [
          {
            text: t('admin.customReports.scheduleReport'),
            callback: handleScheduleReport,
          },
        ]
      : []),
  ];

  return (
    <Box sx={{ mt: 2, mb: 3 }} display='flex' justifyContent='flex-end' alignItems='center'>
      {isScheduleReportEnabled ? (
        <SplitButton optionsMapping={options} dataTestId='reports-dropdown-button' disabled={disabled} />
      ) : (
        <Button
          variant='contained'
          data-testid='create-report-button'
          disabled={disabled}
          onClick={options[0].callback}
        >
          {options[0].text}
        </Button>
      )}
    </Box>
  );
}

ReportsDropdown.defaultProps = {
  onScheduleReport: undefined,
};

export default ReportsDropdown;
